module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-fd9a1088c235d4d12e61184e38a1cd8c.webp";